<script>
  import viewport from '@/js/utils/useViewportAction.js';

  export let cta;
  export let link;
  let grow = false;
</script>

<section
  class="cta"
  class:grow
  use:viewport
  on:enterViewport={() => (grow = true)}
>
  <h3 class="cta__title">{cta.title}</h3>
  <p class="cta__text text-small">{cta.text}</p>
  <div class="cta__more">
    <a href={link.url} class="btn btn-main btn-main--dark btn-icon">
      <span>{link.text}</span>
      <i class="isax isax-arrow-right-1" />
    </a>
  </div>
</section>

<style lang="scss">
  @keyframes fade-up {
    0% {
      opacity: 0;
      transform: translateY(30px);
    }

    75% {
      opacity: 0.5;
    }

    100% {
      opacity: 1;
      transform: translateY(0);
    }
  }
  .cta {
    padding: 10rem 5rem;
    border-bottom: 1px solid $light-border;
    text-align: center;

    &.grow {
      animation: fade-up 1s ease-in-out backwards;
    }

    @include resp-max('m') {
      border-bottom: none;
      border-top: 1px solid $light-border;
      padding: 5rem 3rem 2rem;
      margin-top: 5rem;
    }

    &__title {
      max-width: 70rem;
      margin: 0 auto;
    }

    &__text {
      margin: 2rem auto 0;
      color: var(--royal-light);
      max-width: 70rem;
    }

    &__more {
      margin-top: 2rem;
    }
  }
</style>
